import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=5b0b95ea&scoped=true&"
import script from "./JobCard.vue?vue&type=script&lang=ts&"
export * from "./JobCard.vue?vue&type=script&lang=ts&"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=5b0b95ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b95ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VCol,VIcon,VProgressCircular})
